module.exports = __webpack_public_path__ + "static/media/KettleJoy.dd4406cb.mp3";